import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { RootState } from "@/redux/store";
import { SetStateAction, Dispatch, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";
import { Pallet } from "@/services/Database";
import { useCreatePalletDetailsMutation, useGetPalletDetailsQuery } from "@/redux/slices/pallet/palletApiSlice";
import { PalletType } from "@/redux/slices/pallet/palletSlice";
import { showSuccessToast, showErrorToast } from "../toast/toast";
import { Loader2 } from "lucide-react";
export default function CloneComponent({ title }: { title: string }) {
    const { palletTypes, activePallet } = useSelector((state: RootState) => state.pallets)
    const [clonePallet, setClonePallet] = useState<string | null>('')
    const [isOpen, setIsOpen] = useState<boolean>(false)
    // useEffect(() => {
    //     if (!isOpen && clonePallet !== '') {
    //         setClonePallet(null)
    //     }
    // }, [isOpen])
    return (
        <div className="text-xs flex items-center gap-2 text-blue text-nowrap ml-auto">
            {/* Clone from */}
            <Select value={clonePallet} onValueChange={(value) => setClonePallet(value)}>
                <SelectTrigger className=" rounded-md border-blue h-[28px]">
                    <SelectValue placeholder="Select Pallet to clone from" />
                </SelectTrigger>
                <SelectContent>
                    {
                        palletTypes?.filter((palletType) => palletType?.id !== activePallet?.id).map((palletType) => (
                            <SelectItem value={palletType.id.toString()}>{palletType.variant} - {palletType.name}</SelectItem>
                        ))
                    }
                </SelectContent>
            </Select>

            {clonePallet!=='' && <CloneConfirmation palletToClone={palletTypes.find((palletType) => palletType.id === Number(clonePallet))} activePallet={activePallet} title={title} isOpen={isOpen} setIsOpen={setIsOpen} />}
        </div>
    )
}


export function CloneConfirmation({ isOpen, setIsOpen, title, palletToClone, activePallet }: { isOpen: boolean, setIsOpen: Dispatch<SetStateAction<boolean>>, title: string, palletToClone: PalletType, activePallet: Pallet }) {
    // const { refetch: refetchPalletDetails } = useGetPalletDetailsQuery(activePallet?.id);
    const [createPalletDetails, { isLoading: createPalletDetailsLoading }] = useCreatePalletDetailsMutation();
    const handleClone = async () => {
        try {
            await createPalletDetails({ type: 'clone', palletToCloneId: palletToClone.id, activePalletId: activePallet.id, detailsTitle: title });
            // refetchPalletDetails();
            showSuccessToast('Pallet cloned successfully');
        } catch (error) {
            console.log(error, 'error in clone');
            showErrorToast('Failed to clone pallet');
        }
    }
    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger onClick={(e) => e.stopPropagation()}>
                <Button type="button" className="button-style h-[28px] text-md mt-auto bg-blue hover:bg-[#00336C] flex items-center gap-2 hover:text-white x-space">
                    Clone
                </Button>
            </DialogTrigger>
            <DialogContent className=" z-[1000]">
                <DialogHeader>
                    <DialogTitle>Clone Pallet</DialogTitle>
                </DialogHeader>
                <DialogDescription>
                    <p className="  text-md">Are you sure you want to clone <span className=" font-semibold text-blue">{title}</span> from <span className=" font-semibold text-blue text-lg">{palletToClone.name}</span> to <span className=" font-semibold text-green-600 text-lg">{activePallet.name}</span>?</p>
                </DialogDescription>
                <DialogFooter>
                    <Button type='button' disabled={createPalletDetailsLoading} onClick={(e) => { e.stopPropagation(); handleClone() }}  className="button-style h-[28px] bg-blue flex items-center gap-2 hover:text-white x-space">
                        Clone
                        {createPalletDetailsLoading && <Loader2 className="animate-spin h-4 w-4" />}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
